var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.17,
    height: 31.17,
    viewBox: "0 0 31.17 31.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(-4011.694 -1913.497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M4042.864,1922.857v17.39a4.421,4.421,0,0,1-4.42,4.42h-22.33a4.421,4.421,0,0,1-4.42-4.42v-22.33a4.422,4.422,0,0,1,4.42-4.42h17.39Z",
    fill: "#ff9e0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    d: "M4033.5,1918.437v-4.94l9.36,9.36h-4.94A4.422,4.422,0,0,1,4033.5,1918.437Z",
    fill: "#ffbc4d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M4034.529,1924h-14.5a2,2,0,0,0-2,2v10.16a2,2,0,0,0,2,2h14.5a2,2,0,0,0,2-2V1926A2,2,0,0,0,4034.529,1924Zm-13,2.24a1.755,1.755,0,1,1-1.75,1.76A1.754,1.754,0,0,1,4021.529,1926.242Zm-2.45,10.621,5.11-5.1,1.69,1.7,3.41-3.41,6.61,6.81Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.71b945cbfb6c4d2ab9ade2f60456630b.svg";
export { ForwardRef as ReactComponent };